import React from 'react'
//import defaultBanner from '../../../assets/img/banner/banner_default_photo.jpg'
import defaultBanner from '../../../assets/img/banner/banner-2024.jpg'
import './HeaderBanner.css'

const HeaderBanner = props => {
  const styleBgImage = {
    background: 'url(' + props.bannerImage + ') no-repeat center center',
    backgroundSize: 'cover'
  }

  return (
    <div id="hero" style={ styleBgImage }>
      { props.children }
    </div>
  )
}

HeaderBanner.defaultProps = {
  bannerImage: defaultBanner
}

export default HeaderBanner
